import React, { Component } from 'react'
import cloudinary from 'cloudinary-core'
import { CLOUDINARY_NAME } from '../../../constants/images/cloudinary'
import './BikePhoto.css'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
})
class BikePhoto extends Component {
  buildImageClassName = (imageIndex, imageLength, allImageLength) => {
    if (imageLength === 1) {
      return 'bike-grid-col-1 bike-grid-row-1 image-index-0'
    } else if (imageLength === 2) {
      return 'bike-grid-col-2 bike-grid-row-2-images'
    } else {
      if (imageIndex === 0) {
        return 'bike-grid-col-2 bike-grid-row-2'
      } else if (imageIndex === 4) {
        if (allImageLength > 5) {
          return (
            'bike-grid-image bike-grid-col-1 image-index-' +
            imageIndex +
            ' last-image-five has-more-images'
          )
        } else {
          return (
            'bike-grid--image bike-grid-col-1 image-index-' +
            imageIndex +
            ' last-image-five'
          )
        }
      } else if (imageLength - 1 === imageIndex) {
        return 'bike-grid-image last-image'
      } else {
        return 'bike-grid-image image-index-' + imageIndex
      }
    }
  }
  render() {
    const { profileImage, imageIndex, imageLength, allImageLength } = this.props
    return (
      <>
        <div
          className={this.buildImageClassName(
            imageIndex,
            imageLength,
            allImageLength
          )}
          onClick={() => this.props.toggleModal()}
        >
          <img src={cl.url(profileImage.bike_image_url)} alt="bike-image"></img>
          {imageIndex === 4 && allImageLength > 5 && (
            <div class="centered-profile-pic-text ">+ {allImageLength - 5}</div>
          )}
        </div>
      </>
    )
  }
}

export default BikePhoto
